// These are our 'main' roles that we use to generally categorize members, e.g. the ones that have their own badge icons
const MEMBER_ROLES = {
    ADMIN: 'ROLE_ADMIN',
    AMBASSADOR: 'ROLE_AMBASSADOR',
    ACTIVITY_GROUP_CONSUL: 'ROLE_ACTIVITY_GROUP_CONSUL',
    NEWCOMER_BUDDY: 'ROLE_NEWCOMER_BUDDY',
    ALBATROSS: 'ROLE_ALBATROSS',
    USER: 'ROLE_USER',
} as const

export default MEMBER_ROLES
